<div class="highlight-list-box" (click)="goTo()">
  <div class="background-sect" [ngStyle]="{'background-image': 'url(' + highlight?.icon + ')'}"></div>
</div>
<div class="pt-8px mw-64px center no-scroll-y lh-12px" (click)="goTo()">
  <span class="f-12px f-gray break-line">
    {{highlight?.name}}
  </span>
</div>